module.exports = __webpack_public_path__ + "static/image/history/m/201303@3x.jpg?fb3a9f41";